<template>
  <div>
    <div class="navbar" >
      <el-menu :default-active="activeName" mode="horizontal" @select="selectMenu">
        <el-menu-item index="data">
          <span class="menu-icon">📊</span>
          <span>数据平台及报表可视化</span>
        </el-menu-item>
        <el-menu-item index="crm">
          <span class="menu-icon">👥</span>
          <span>客户管理及精准营销</span>
        </el-menu-item>
        <el-menu-item index="hr">
          <span class="menu-icon">👨‍💼</span>
          <span>人力资源及绩效考核管理</span>
        </el-menu-item>
        <el-menu-item index="credit">
          <span class="menu-icon">💰</span>
          <span>信贷全流程管理</span>
        </el-menu-item>
        <el-menu-item index="workflow">
          <span class="menu-icon">⚙️</span>
          <span>流程优化及内部管理</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="container">
      <div class="sidebar">
        <div class="sidebar-inner">
          <p class="sidebar-title">产品导航</p>
          <ul class="sidebar-list">
            <li
              v-for="item in subMenus[activeName]"
              :key="item"
              class="sidebar-item"
              :class="{ active: activeSub === item }"
              @click="scrollToSection(item)">
              <span class="sidebar-dot"></span>
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <div class="main-content">
      <div v-show="activeName == 'data'">
        <div class="platform-intro">
          <h2 class="f-s-32 f-bolder">数据平台及报表可视化</h2>
          <p class="f-s-18 f-grey-7">企业数字化转型核心数据底座</p>
          <p class="f-s-16 f-grey-7 platform-desc">
            同儒信息数据平台，打通数据孤岛，构建统一数据资产体系，提供<strong>数据治理、调度管控、报表分析、可视化洞察</strong>全链路能力，为经营决策、业务创新提供高质量数据支撑。
          </p>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">数据仓库系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">企业数据资产的核心载体，保障数据稳定、可靠、高质量流转。</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">全链路调度管控</h4>
                <p class="f-s-14 f-grey-7">覆盖作业、服务、节点实时监控，支持异常预警、人工干预，保障数据7×24小时稳定运行。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">多层级数据集成</h4>
                <p class="f-s-14 f-grey-7">支持ODS、基础层、汇总层、集市层数据统一集成，适配多业务数据加工需求。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">标准化数据治理</h4>
                <p class="f-s-14 f-grey-7">内置多维度数据标准，统一格式、清洗、校验规则，从源头保障数据质量。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">智能异常预警</h4>
                <p class="f-s-14 f-grey-7">资源、调度、数据异常实时提醒，快速发现、及时处置，降低业务风险。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">统一数据标准、稳定数据链路、保障数据质量、夯实数据资产底座。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">报表平台及数据可视化系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">低代码数据应用工具，让数据价值直观呈现，赋能快速决策。</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">全场景报表管理</h4>
                <p class="f-s-14 f-grey-7">支持管理报表、监管报表快速构建、统一管理、权限可控，满足经营与合规需求。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">拖拽式可视化看板</h4>
                <p class="f-s-14 f-grey-7">零代码搭建经营、风控、业绩等可视化看板，支持交互钻取、大屏轮播展示。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">便捷数据浏览</h4>
                <p class="f-s-14 f-grey-7">报表、看板快速查询、收藏、多端适配，随时随地获取数据洞察。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">精细化权限管控</h4>
                <p class="f-s-14 f-grey-7">按角色、岗位灵活配置查看、编辑、导出权限，兼顾数据共享与安全合规。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">释放数据价值、赋能业务洞察、支撑科学决策、提升运营效率。</span>
          </div>
        </div>
      </div>
      <div v-show="activeName == 'crm'">
        <div class="platform-intro">
          <h2 class="f-s-32 f-bolder">客户管理及精准营销</h2>
          <p class="f-s-18 f-grey-7">全渠道获客，精细化运营</p>
          <p class="f-s-16 f-grey-7 platform-desc">
            同儒信息客户管理体系，覆盖<strong>外呼营销、全域营销、私域运营、厅堂营销、普惠走访、商户经营、对公管理、客群分层、权益运营</strong>全场景，助力企业实现精准获客、高效转化与客户价值持续增长。
          </p>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">外呼营销管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">电话营销全流程管控，高效触达客户</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">工作台与工单管理</h4>
                <p class="f-s-14 f-grey-7">待处理工单、外呼记录、未接来电统一管理，支持提醒工单设置与回访跟进。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户网格管理</h4>
                <p class="f-s-14 f-grey-7">客户管户划分、标签配置、精准筛选，支持岗位变动后客户批量转移。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">动态工单配置</h4>
                <p class="f-s-14 f-grey-7">按业务场景配置工单字段，支持Excel批量导入与分配，适配不同营销场景。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">录音与报表看板</h4>
                <p class="f-s-14 f-grey-7">录音查询/下载，营销数据可视化看板，实时统计工单处理与转化情况。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">提升外呼效率，规范营销行为，降低合规风险，实现电话营销的标准化、可追溯管理。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">营销管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">全渠道营销活动统一管控，精准获客</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户管理</h4>
                <p class="f-s-14 f-grey-7">客户列表、标签配置、批量转移，支持按客户标签、名称、地址等多维度筛选。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">工单管理</h4>
                <p class="f-s-14 f-grey-7">工单配置、导入、处理全流程线上化，支持工单填写、转单、提醒。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">定时营销模型</h4>
                <p class="f-s-14 f-grey-7">根据业务需要定时生成工单，实现营销活动的自动化执行。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">报表与可视化</h4>
                <p class="f-s-14 f-grey-7">营销数据多维度统计，以直观看板展示活动执行与转化效果。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">客户查询、视图查看、工单处理、提醒管理，随时随地开展营销。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现营销活动的全流程闭环管理，提升营销效率与投入产出比。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">私域营销系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">企业微信私域运营，客户价值深度挖掘</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">企业微信管理</h4>
                <p class="f-s-14 f-grey-7">通讯录同步、素材配置、场景回复、标签管理，实现私域客户的精细化运营。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户群管理</h4>
                <p class="f-s-14 f-grey-7">群聊数据自动同步，批量加好友、打标签，支持客户群聊数据统计与维护。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">群发与朋友圈营销</h4>
                <p class="f-s-14 f-grey-7">按标签筛选客户群发消息/朋友圈任务，支持定时发布与效果统计。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">裂变营销活动</h4>
                <p class="f-s-14 f-grey-7">配置裂变活动内容、奖励机制，支持客户分享传播与权益核销。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">积分与权益管理</h4>
                <p class="f-s-14 f-grey-7">客户积分台账、权益配置、礼品兑换，提升客户活跃度与粘性。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">构建企业私域流量池，通过内容运营与裂变活动，实现客户长期价值挖掘。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">厅堂营销系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">线下网点客户营销，提升厅堂转化</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户来访管理</h4>
                <p class="f-s-14 f-grey-7">对接叫号机数据，按待办/已跟进/已营销分类展示来访客户，记录客户需求与营销情况。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户信息视图</h4>
                <p class="f-s-14 f-grey-7">客户基本信息、联系方式、持有产品、家庭资产情况、账户明细一站式查看。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">产品库与话术管理</h4>
                <p class="f-s-14 f-grey-7">录入厅堂营销产品信息，配置多组营销话术，辅助厅堂人员精准推介。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">营销数据看板</h4>
                <p class="f-s-14 f-grey-7">来访数、推荐产品数、营销登记数、登记率等关键指标可视化展示。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">提升厅堂网点客户识别与转化效率，优化客户服务体验，挖掘线下渠道价值。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">客户分层分类及精准营销系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">客户画像与分层运营，实现千人千面</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户模型配置</h4>
                <p class="f-s-14 f-grey-7">客户等级、综合黏性、信息完整度、标签模型自定义配置，构建客户360°画像。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户分层管理</h4>
                <p class="f-s-14 f-grey-7">按客户等级、AUM、生命周期、流失倾向等多维度分层，支持标签筛选与精准触达。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户360°视图</h4>
                <p class="f-s-14 f-grey-7">整合客户信息、标签、产品、交易、风险等全维度数据，形成统一客户视图。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">营销活动管理</h4>
                <p class="f-s-14 f-grey-7">按客户分层配置营销活动，支持任务分发、执行跟踪与效果统计。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">客户查询、视图查看、营销活动执行、提醒管理，随时随地开展客户运营。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现客户精细化运营与精准营销，提升客户转化率与满意度。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">普惠走访及网格化管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">普惠金融网格化运营，下沉客户服务</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">网格管理</h4>
                <p class="f-s-14 f-grey-7">支持物理/逻辑网格建立、分配、移交，实现普惠客户的网格化划分与责任到人。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">普惠走访管理</h4>
                <p class="f-s-14 f-grey-7">走访签到、信息维护、需求收集、影像拍摄全流程记录，支持批量客户导入与建档。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">普惠授信模型</h4>
                <p class="f-s-14 f-grey-7">准入模型、授信模型配置与管理，支持额度查询与人工干预，提升授信效率。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">可视化看板</h4>
                <p class="f-s-14 f-grey-7">普惠走访、客户分层分类数据可视化展示，实时监控业务进展。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现普惠业务的规模化、精细化运营，提升客户拓展效率与服务质量。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">商户营销管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">商户客群全生命周期经营，提升商户价值</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">商户数据接入</h4>
                <p class="f-s-14 f-grey-7">对接省行商户管理系统，整合商户交易、客户、产品信息，构建商户全维度画像。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">商户走访与巡检</h4>
                <p class="f-s-14 f-grey-7">走访工单配置、计划管理、异常工单处理，实现商户维护的标准化流程。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">商户权益管理</h4>
                <p class="f-s-14 f-grey-7">权益方案配置、账户管理、流水查询，支持积分、红包等权益类型，提升商户活跃度。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">风险与售后管理</h4>
                <p class="f-s-14 f-grey-7">商户风险指标配置、工单处理、售后工单管理，实现商户风险的早识别早处置。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">商户查询、走访巡检、售后工单、权益兑换，随时随地开展商户运营。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现商户客群的精细化运营与风险管控，提升商户交易规模与粘性。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">企业管理平台（对公客户管理）</h3>
          <p class="f-s-16 f-grey-7 section-desc">对公客户全生命周期管理，提升合作价值</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户管理</h4>
                <p class="f-s-14 f-grey-7">对公客户列表、查询、关注管理，支持客户信息批量导入与导出。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">网格与走访管理</h4>
                <p class="f-s-14 f-grey-7">物理/逻辑网格建立、分配、移交，走访工单生成、执行、管控全流程线上化。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户等级与贡献度管理</h4>
                <p class="f-s-14 f-grey-7">客户重要度、贡献度等级配置与查询，支持等级调整与审批。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">营销与提醒管理</h4>
                <p class="f-s-14 f-grey-7">营销工单派发、执行跟踪，客户生日、成立日、贷款到期等提醒配置。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">客户查询、走访预约、工单处理、提醒管理，随时随地开展对公业务。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现对公客户的精细化运营与全流程风险管控，提升客户服务效率与合作深度。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">客群管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">全量客群统一管理，支撑精细化运营</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客群数据整合</h4>
                <p class="f-s-14 f-grey-7">打通多渠道客户数据，实现客户信息的统一归集与标准化管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户标签体系</h4>
                <p class="f-s-14 f-grey-7">支持多维度客户标签配置与管理，实现客户的自动化分层分类。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客群生命周期管理</h4>
                <p class="f-s-14 f-grey-7">根据客户行为与价值变化，动态更新客群分层，支撑全生命周期运营。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">数据统计分析</h4>
                <p class="f-s-14 f-grey-7">客群规模、价值贡献、流失情况等多维度统计，为营销策略优化提供数据支撑。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">构建企业统一的客户数据资产，为精准营销、差异化服务提供数据基础。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">客户权益系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">客户权益全生命周期管理，提升客户粘性</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">积分账户管理</h4>
                <p class="f-s-14 f-grey-7">客户积分台账、查询、调整、赠送全流程管理，支持积分规则与兑换率配置。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">积分消费管理</h4>
                <p class="f-s-14 f-grey-7">积分消费订单管理、流水查询、差错处理，实现积分消费的闭环管控。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">礼品与权益管理</h4>
                <p class="f-s-14 f-grey-7">礼品分类、入库、调拨、领用全流程管理，支持线上/线下权益配置与核销。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">积分商城运营</h4>
                <p class="f-s-14 f-grey-7">微信端积分商城搭建，商品展示、订单管理、商户管理，支持客户扫码消费与权益兑换。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">通过多元化权益体系，提升客户活跃度、粘性与满意度，增强客户品牌认同感。</span>
          </div>
        </div>
      </div> 
      <div v-show="activeName == 'hr'">
        <div class="platform-intro">
          <h2 class="f-s-32 f-bolder">人力资源及绩效考核管理</h2>
          <p class="f-s-18 f-grey-7">数据驱动，高效合规</p>
          <p class="f-s-16 f-grey-7 platform-desc">
            同儒信息人力资源及绩效考核管理体系，围绕<strong>人力资源、员工行为、绩效考核</strong>三大核心，打造一体化、数字化、智能化人力管理平台，助力组织提效、风险可控、人才赋能。
          </p>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">人力资源管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">一站式人事管理，提效降本</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">组织架构管理</h4>
                <p class="f-s-14 f-grey-7">可视化组织树、岗位/职务/职级标准化配置，灵活适配组织变革。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">员工全生命周期</h4>
                <p class="f-s-14 f-grey-7">入职、异动、合同、花名册、人事事务全流程线上化。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">考勤假期管理</h4>
                <p class="f-s-14 f-grey-7">考勤统计、请假调休、假期精细化管控。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">薪酬福利管理</h4>
                <p class="f-s-14 f-grey-7">薪酬项配置、自动核算、工资单发放、社保公积金管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">员工积分管理</h4>
                <p class="f-s-14 f-grey-7">按积分方案，业绩、培训、奖励、活动可获积分；违规可扣分；积分用于等级、晋升、福利、礼品兑换。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">培训管理</h4>
                <p class="f-s-14 f-grey-7">培训计划、签到、考核、培训过程全流程管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动自助办公</h4>
                <p class="f-s-14 f-grey-7">移动端查信息、考勤、审批，提升员工体验。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">人事流程标准化、数据一体化、管理高效化、用工合规化。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">员工行为管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">员工行为智能风控，防患未然</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">多源数据整合</h4>
                <p class="f-s-14 f-grey-7">对接外部司法、公安、监管数据，整合内部人事、积分、流水信息。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">员工分级管控</h4>
                <p class="f-s-14 f-grey-7">红黄蓝分级、动态评级、分级处置。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">风险预警闭环</h4>
                <p class="f-s-14 f-grey-7">行为模型、智能预警、工单处置、整改跟踪。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">网格化管理</h4>
                <p class="f-s-14 f-grey-7">员工网格划分、责任到人、精细化管控。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">积分与处罚</h4>
                <p class="f-s-14 f-grey-7">违规积分、复议、台账管理、处罚追溯。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">谈心与学习</h4>
                <p class="f-s-14 f-grey-7">谈心谈话、制度学习、合规培训。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">行为风险早识别、早预警、早处置，降低运营风险。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">绩效考核管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">科学考核，公平激励</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">业绩关系管理</h4>
                <p class="f-s-14 f-grey-7">业绩归属、业绩转移、精准核算。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">目标计划管理</h4>
                <p class="f-s-14 f-grey-7">目标制定、分解、跟踪、自动预警。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">多维指标管理</h4>
                <p class="f-s-14 f-grey-7">系统指标、人工指标、增量指标灵活配置。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">考核方案配置</h4>
                <p class="f-s-14 f-grey-7">KPI/OKR/多方案支持，可自定义规则。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">薪酬联动</h4>
                <p class="f-s-14 f-grey-7">考核结果自动算薪、延期支付、二次分配。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">可视化看板</h4>
                <p class="f-s-14 f-grey-7">考核排名、目标进度、业绩分析。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">考核透明、激励有效、数据驱动，激发组织活力。</span>
          </div>
        </div>
      </div> 
      <div v-show="activeName == 'lcyh'">
        <el-tabs tab-position="left" >
          <el-tab-pane label="行政办公">
            <p class="f-s-16 f-grey-7" style="padding: 20px;">
              综合办公系统涵盖了全行交办督办、收文、发文、用印等日常管理流程，以及各部室业务流程表单。由同儒项目组与各部门进行交流讨论，确定业务流程范围，逐一确定各业务流程表单、业务流程。系统和移动工作平台紧密集成，员工可以通过平板电脑、手机实现异地远程交办、督办事务，签发审阅文件以及无纸化的审阅。
            </p>
          </el-tab-pane>
          <el-tab-pane label="科技管理">
            <p class="f-s-16 f-grey-7" style="padding: 20px;">
              实现科技机房管理、机柜管理、设备管理、机房事件、IP管理、虚拟机管理、业务应用管理、日常登记管理、项目需求管理、科技检查、以及其他内部管理。
            </p>
          </el-tab-pane>
          <el-tab-pane label="预算费用">
            <p class="f-s-16 f-grey-7" style="padding: 20px;">
              费用预算管理系统主要实现费用预算额度管理，每年年初形成我行年度预算计划,该计划将按照预算科目和我行组织机构进行分解，预算完成后将针对预算形成相应的费用控制目标。
              系统涵盖预算科目管理、预算录入、预算申报、预算使用情况查询、超预算申请、费用申请管理、财务借款/还款管理、费用报销管理、财务凭证管理、发票管理等主要功能。

            </p>
          </el-tab-pane>
          <el-tab-pane label="物资管理">
            <p class="f-s-16 f-grey-7" style="padding: 20px;">
              通过IT系统对低值易耗品、固定资产采购、库存、领用等业务操作进行全流程控制；实现相关财务管理、招投标、合同固定资产、低值易耗品等过程的电子化档案管理；辅助内部成本分摊、成本核算。主要功能包括：物品采购申请、采购、入库、领用、出库、调拨、盘点、库存查询、仓库设置、资产登记、上账、领用、交接、盘点、查询、折旧、统计分析以及与费用预算系统的集成等。
            </p>
          </el-tab-pane>
          <el-tab-pane label="风险责任制">
            <p class="f-s-16 f-grey-7" style="padding: 20px;">责任划分、风险金管理</p>
          </el-tab-pane>
          <!--
          <el-tab-pane label="信贷档案">
            <p class="f-s-16 f-grey-7" style="padding: 20px;"></p>
          </el-tab-pane>
          
          <el-tab-pane label="贷后管理">
            <p class="f-s-16 f-grey-7" style="padding: 20px;"></p>
          </el-tab-pane>
          <el-tab-pane label="不良资产">
            <p class="f-s-16 f-grey-7" style="padding: 20px;"></p>
          </el-tab-pane>
          -->
        </el-tabs>
      </div> 

      <div v-show="activeName == 'credit'">
        <div class="platform-intro">
          <h2 class="f-s-32 f-bolder">信贷全流程管理</h2>
          <p class="f-s-18 f-grey-7">从准入到处置，全周期风险闭环管控</p>
          <p class="f-s-16 f-grey-7 platform-desc">
            同儒信息信贷全流程管理体系，覆盖<strong>贷前、贷中、贷后、不良处置、档案管理、责任认定</strong>全生命周期，构建标准化、可追溯、智能化的信贷风险管控体系，保障信贷业务合规稳健发展。
          </p>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">贷前管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">授信准入智能管控，从源头把控风险</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">客户授信申请</h4>
                <p class="f-s-14 f-grey-7">支持对公/对私客户授信工单线上填报，覆盖贷款信息、经营状况、担保方式、调查结论等全维度信息采集。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">授信模型管理</h4>
                <p class="f-s-14 f-grey-7">自定义授信指标模型、测算对象与指标定义，实现授信额度的智能化测算与审批。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">业务基础配置</h4>
                <p class="f-s-14 f-grey-7">产品信息、档案分类、业务资料、机构授权额度等统一配置，适配不同产品与机构的授信规则。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">个人授信测算、调查信息录入、记录查询，随时随地完成贷前调查工作。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">标准化贷前流程，提升授信审批效率，从源头识别并防范信贷风险。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">贷后管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">贷后风险动态监控，及时预警处置</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">贷后检查管理</h4>
                <p class="f-s-14 f-grey-7">检查计划配置、工单生成、五级分类变更流程管理，实现贷后检查全流程线上化。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">贷款催收管理</h4>
                <p class="f-s-14 f-grey-7">到期贷款查询、催收工单流程管理，支持催收记录与进度跟踪。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">不良与诉讼管理</h4>
                <p class="f-s-14 f-grey-7">不良贷款台账查询、诉讼申请流程管理，实现不良资产的规范化处置。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">责任与风险管理</h4>
                <p class="f-s-14 f-grey-7">贷款责任认定台账、风险指标配置、模型库管理，自动生成风险工单。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">催收工单、诉讼申请、风险工单查询与处理，随时随地开展贷后管理工作。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现贷后风险的实时监控、预警与处置，保障信贷资产安全。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">不良管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">不良资产全流程处置，最大化资产回收</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">不良贷款台账管理</h4>
                <p class="f-s-14 f-grey-7">整合不良贷款客户信息、借款人信息、还款意愿/能力标签、催收记录、还款计划，实现不良资产的统一管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">催收与诉讼管理</h4>
                <p class="f-s-14 f-grey-7">催收工单派发、诉讼申请流程管理，支持诉讼文书一键生成与进度跟踪。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">时效提醒与报表</h4>
                <p class="f-s-14 f-grey-7">诉讼提醒、账户变动提醒、清收还款提醒，多维度报表看板统计处置进度与效果。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">不良台账查询、催收工单处理、诉讼信息查询，随时随地推进不良处置工作。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">规范不良资产处置流程，提升处置效率与回收率，最大限度降低资产损失。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">信贷档案管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">信贷档案数字化管理，合规可追溯</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">档案全生命周期管理</h4>
                <p class="f-s-14 f-grey-7">覆盖信贷案卷的生成、移交、借阅、销毁全流程，支持总行与支行两级档案管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">电子化档案管理</h4>
                <p class="f-s-14 f-grey-7">扫描信贷档案，支持电子档案的分类存储、查询与调阅，实现档案的线上化管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">系统配置管理</h4>
                <p class="f-s-14 f-grey-7">档案模板配置、存储路径设置、资料分类管理，适配不同担保方式、客户类型的档案管理需求。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">权限管控</h4>
                <p class="f-s-14 f-grey-7">配置档案查看、借阅、修改权限，保障信贷档案的安全性与合规性。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现信贷档案的标准化、电子化管理，提升档案管理效率，满足合规审计要求。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">贷款责任制管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">信贷责任全流程认定，强化责任意识</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">风险责任管理</h4>
                <p class="f-s-14 f-grey-7">贷款责任台账、责任移交、责任认定全流程管理，实现信贷业务责任的精准划分与追溯。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">风险金管理</h4>
                <p class="f-s-14 f-grey-7">风险金计算、账户管理，将信贷责任与风险金挂钩，强化从业人员责任意识。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">系统配置管理</h4>
                <p class="f-s-14 f-grey-7">不良容忍度、缴存系数、责任划分模板、支行权限配置，适配不同机构的责任管理规则。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">构建全流程、可追溯的信贷责任管理体系，规范信贷业务操作，防范操作风险与道德风险。</span>
          </div>
        </div>
      </div>

      <div v-show="activeName == 'workflow'">
        <div class="platform-intro">
          <h2 class="f-s-32 f-bolder">流程优化及内部管理</h2>
          <p class="f-s-18 f-grey-7">精益化运营，全流程提效</p>
          <p class="f-s-16 f-grey-7 platform-desc">
            同儒信息流程优化及内部管理体系，覆盖<strong>数智办公、预算费用、科技管理、物资管理、项目管理</strong>全场景，助力企业实现流程数字化、管理精益化、运营高效化，降低管理成本，强化内控能力。
          </p>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">数智办公管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">一站式协同办公，流程高效流转</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">全流程审批管理</h4>
                <p class="f-s-14 f-grey-7">覆盖公文、会议、合同、用车、印章、采购等全场景审批流程，支持可视化流程配置，适配各部门个性化需求。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">多部门业务支撑</h4>
                <p class="f-s-14 f-grey-7">办公室、保卫保障部、财务管理部、合规风险部、会计运营部、零售金融部、普惠金融部、审计部、业务管理部等部门业务统一线上化办理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">公文与信息管理</h4>
                <p class="f-s-14 f-grey-7">收文、发文、请示报告、公告通知、行内新闻、档案管理等全流程线上化，支持文件传阅、归档与查询。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端适配</h4>
                <p class="f-s-14 f-grey-7">随时随地发起申请、审批流程、查看待办，打破办公时间与空间限制。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现企业内部办公流程的标准化、自动化，提升跨部门协同效率，降低沟通成本。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">预算费用管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">预算管控闭环，成本精准可控</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">费用全流程管理</h4>
                <p class="f-s-14 f-grey-7">费用申请、报销、借还款、发票管理全流程线上化，支持按年度预算科目申请，关联合同与发票信息。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">预算管理</h4>
                <p class="f-s-14 f-grey-7">预算申报、项目预算管理、预算使用明细查询，实时监控预算执行情况，实现事前、事中、事后全流程管控。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">财务会办管理</h4>
                <p class="f-s-14 f-grey-7">财务审核小组成员配置、预算申报会办配置，规范财务审批流程，强化内控管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">费用申请、报销、还款等操作移动端办理，提升财务处理效率。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">规范费用管理流程，强化预算执行力度，降低运营成本，提升财务管理精益化水平。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">科技管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">科技资产与运维全生命周期管控</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">内部管理</h4>
                <p class="f-s-14 f-grey-7">科技规划、制度、软件台账、出入机房申请、业务开户、权限修改等全流程管理，规范科技管理流程。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">机房网络管理</h4>
                <p class="f-s-14 f-grey-7">机房、机柜、设备、IP、虚拟机、业务应用全维度管理，实时监控设备状态，保障系统稳定运行。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">运行维护管理</h4>
                <p class="f-s-14 f-grey-7">数据维护、系统事件处理、科技报告上报、权限修改申请、故障申报、附件审批等运维流程线上化。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">日常登记与项目管理</h4>
                <p class="f-s-14 f-grey-7">机房出入、值班、安全检查、密码变更等登记台账管理，支持科技项目需求申请、开发测试、功能上线、BUG登记全流程跟踪。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现科技资产、运维流程、项目管理的标准化管控，保障系统安全稳定运行，提升科技管理效率。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">物资管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">采购与物资全流程闭环管理</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">消耗品管理</h4>
                <p class="f-s-14 f-grey-7">消耗品分类、产品、库存管理，支持领用、归还、盘点全流程线上化，实时监控库存状态。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">出入库与调拨管理</h4>
                <p class="f-s-14 f-grey-7">采购入库、出库、调拨流程管理，支持流水工单查询，规范物资流转，避免账实不符。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">固定资产管理</h4>
                <p class="f-s-14 f-grey-7">固定资产分类、台账、调拨、借用、归还、维修、租赁、报废全流程管理，实现固定资产的全生命周期管控。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">物品领用、归还、调拨、资产盘点等操作移动端办理，随时随地跟踪物资状态。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">规范物资采购与管理流程，降低采购成本，提升库存周转效率，保障物资供应稳定。</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="platform-section">
          <h3 class="f-s-24 f-bolder section-title">PMO管理系统</h3>
          <p class="f-s-16 f-grey-7 section-desc">项目目标与进度可视化管控</p>

          <div class="feature-grid">
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">OKR目标管理</h4>
                <p class="f-s-14 f-grey-7">支持全行/机构/个人OKR目标配置，清晰展示目标、关键结果、执行计划与进度，实现目标可视化管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">项目进度管控</h4>
                <p class="f-s-14 f-grey-7">通过OKR看板实时展示目标完成情况，支持颜色区分已完成/未完成/到期目标，直观呈现工作进展。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">任务与计划管理</h4>
                <p class="f-s-14 f-grey-7">基于OKR目标生成待办任务（TODO），支持优先级配置与提醒，覆盖周计划、工作计划的全流程管理。</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">✅</div>
              <div class="feature-content">
                <h4 class="f-s-18 f-bolder">移动端支持</h4>
                <p class="f-s-14 f-grey-7">OKR看板、待办任务、工作计划移动端查看与处理，随时随地跟踪项目进度。</p>
              </div>
            </div>
          </div>

          <div class="value-box">
            <span class="value-label">价值：</span>
            <span class="value-text">实现项目目标与进度的全流程管控，提升项目交付效率与成功率，支撑企业战略目标落地。</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
  import { AdProduct } from '@icon-park/vue'
  
  export default {
    components: { AdProduct },
    data() {
      return {
        activeName: 'data',
        activeSub: '',
        subMenus: {
          data: ['数据仓库系统', '报表平台及数据可视化系统'],
          crm: ['外呼营销管理系统', '营销管理系统', '私域营销系统', '厅堂营销系统', '客户分层分类及精准营销系统', '普惠走访及网格化管理系统', '商户营销管理系统', '企业管理平台（对公客户管理）', '客群管理系统', '客户权益系统'],
          hr: ['人力资源管理系统', '员工行为管理系统', '绩效考核管理系统'],
          credit: ['贷前管理系统', '贷后管理系统', '不良管理系统', '信贷档案管理系统', '贷款责任制管理系统'],
          workflow: ['数智办公管理系统', '预算费用管理系统', '科技管理系统', '物资管理系统', 'PMO管理系统']
        },
        bigdata: require('./imgs/bigdata.png'),
        crm: require('./imgs/crm.png'),
        phzf: require('./imgs/phzf.png'),
        jf: require('./imgs/jf.png'),
        cs: require('./imgs/cs.png'),
        hr: require('./imgs/hr.png'),
        empjf: require('./imgs/empjf.png'),
        jx: require('./imgs/jx.png')
      }
    },
    created() {
      if (this.$route.query.type) {
        this.activeName = this.$route.query.type
      }
    },
    mounted() {
      this.handleSubParam()
    },
    watch: {
      $route(to, from) {
        if (to.query.type) {
          this.activeName = to.query.type
        }
        this.$nextTick(() => {
          this.handleSubParam()
        })
      }
    },
    activated() {
      if (this.$route.query.type) {
        this.activeName = this.$route.query.type
      }
      this.handleSubParam()
    },
    methods: {
      handleSubParam() {
        const sub = this.$route.query.sub
        if (sub) {
          const waitForScrollTop = () => {
            const container = document.querySelector('.app-container')
            if (container && container.scrollTop <= 1) {
              this.scrollToSection(sub)
            } else {
              setTimeout(waitForScrollTop, 30)
            }
          }
          setTimeout(waitForScrollTop, 50)
        }
      },
      selectMenu(index) {
        this.activeName = index
        this.activeSub = ''
        this.$nextTick(() => {
          const el = document.querySelector('.app-container')
          if (el) el.scrollTo({ top: 0, behavior: 'smooth' })
        })
      },
      scrollToSection(section) {
        this.activeSub = section
        const headings = this.$el.querySelectorAll('.section-title')
        for (const h of headings) {
          if (h.textContent.trim() === section) {
            const container = document.querySelector('.app-container')
            if (container) {
              const offset = h.getBoundingClientRect().top + container.scrollTop - 100
              container.scrollTo({ top: offset, behavior: 'smooth' })
            }
            break
          }
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  
  .navbar {
    padding: 12px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    background: linear-gradient(135deg, #0d1421 0%, #151d2e 40%, #1a2438 100%);
    box-shadow: 0 4px 28px rgba(0, 0, 0, 0.25);
    position: sticky;
    top: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);

    .el-menu {
      background: transparent;
    }

    .el-menu-item {
      padding: 10px 22px;
      color: rgba(255, 255, 255, 0.82);
      font-size: 14px;
      font-weight: 500;
      border-radius: 24px;
      height: auto;
      line-height: 1.4;
      margin: 0 5px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.06);
      backdrop-filter: blur(8px);
      border: 1px solid transparent;
    }
    
    .menu-icon {
      font-size: 16px;
      margin-right: 7px;
      flex-shrink: 0;
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .el-menu-item:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.18);
      border-color: rgba(255, 255, 255, 0.25);
      transform: translateY(-1px);
      
      .menu-icon {
        transform: scale(1.15);
      }
    }

    .el-menu-item.is-active {
      color: #1a56b8;
      background: #fff;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      border-color: #fff;
      transform: translateY(-1px);
      font-weight: 600;
      
      .menu-icon {
        transform: scale(1.15);
      }
    }

    }

  .container {
    display: flex;
    gap: 0;
    padding: 0;
    min-height: calc(100vh - 72px);
    background: #f5f7fa;

    .sidebar {
      width: 240px;
      flex-shrink: 0;
      background: #fff;
      border-right: 1px solid rgba(26, 86, 184, 0.06);
      position: sticky;
      top: 72px;
      align-self: flex-start;
      max-height: calc(100vh - 72px);
      overflow-y: auto;

      .sidebar-inner {
        padding: 28px 20px;
      }

      .sidebar-title {
        font-size: 15px;
        font-weight: 700;
        color: #1a56b8;
        margin: 0 0 18px 0;
        padding-left: 12px;
        border-left: 3px solid #1a56b8;
      }

      .sidebar-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .sidebar-item {
        display: flex;
        align-items: center;
        padding: 11px 14px;
        font-size: 14px;
        color: #555;
        cursor: pointer;
        border-radius: 8px;
        margin-bottom: 2px;
        transition: all 0.2s ease;
        border: 1px solid transparent;

        .sidebar-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(26, 86, 184, 0.15);
          margin-right: 10px;
          flex-shrink: 0;
          transition: all 0.25s ease;
        }

        &:hover {
          color: #1a56b8;
          background: rgba(26, 86, 184, 0.04);
          border-color: rgba(26, 86, 184, 0.08);

          .sidebar-dot {
            background: #1a56b8;
            transform: scale(1.3);
          }
        }

        &.active {
          color: #1a56b8;
          font-weight: 600;
          background: rgba(26, 86, 184, 0.06);
          border-color: rgba(26, 86, 184, 0.12);

          .sidebar-dot {
            background: #1a56b8;
            width: 8px;
            height: 8px;
          }
        }
      }
    }

    .main-content {
      flex: 1;
      min-width: 0;
      padding: 48px 5%;
      background: linear-gradient(180deg, #f0f4f8 0%, #f5f7fa 30%, #ffffff 100%);

    ::v-deep .el-divider--horizontal {
      margin: 36px 0;
      background: linear-gradient(90deg, transparent, rgba(26, 86, 184, 0.12), transparent);
      height: 1px;

      .el-divider__text {
        display: none;
      }
    }
  }

  .platform-intro {
    text-align: center;
    padding: 40px 48px 48px;
    background: #fff;
    border-radius: 20px;
    margin-bottom: 28px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(26, 86, 184, 0.06);

    h2 {
      margin-bottom: 12px;
      font-size: 34px;
      font-weight: 700;
      background: linear-gradient(135deg, #1a56b8 0%, #174291 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    p {
      margin: 8px 0;
    }

    .platform-desc {
      max-width: 860px;
      margin: 22px auto 0;
      line-height: 1.9;
      color: #5a5b5c;
      font-size: 15px;
    }
  }

  .platform-section {
    padding: 36px 40px;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(26, 86, 184, 0.06);

    .section-title {
      color: #1a56b8;
      margin-bottom: 12px;
      font-size: 22px;
      font-weight: 600;
      display: flex;
      align-items: center;
      scroll-margin-top: 130px;
    }

    .section-title::before {
      content: '';
      width: 4px;
      height: 22px;
      background: linear-gradient(180deg, #1a56b8 0%, #3b82f6 100%);
      border-radius: 2px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .section-desc {
      margin-bottom: 32px;
      line-height: 1.8;
      color: #646566;
      padding-left: 16px;
    }
  }

  .feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
    gap: 18px;
    margin-top: 0;
  }

  .feature-item {
    display: flex;
    align-items: flex-start;
    padding: 22px 24px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 14px;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(26, 86, 184, 0.06);

    &:hover {
      background: #fff;
      box-shadow: 0 8px 28px rgba(26, 86, 184, 0.1);
      transform: translateY(-3px);
      border-color: rgba(26, 86, 184, 0.15);
    }

    .feature-icon {
      font-size: 26px;
      margin-right: 16px;
      flex-shrink: 0;
      transition: transform 0.3s ease;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #e8f0fe 0%, #dbeafe 100%);
      border-radius: 10px;
    }

    &:hover .feature-icon {
      transform: scale(1.12);
    }

    .feature-content {
      flex: 1;

      h4 {
        color: #1f2937;
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
      }

      p {
        line-height: 1.7;
        color: #6b7280;
        font-size: 14px;
      }
    }
  }

  .value-box {
    margin-top: 28px;
    padding: 18px 24px;
    background: linear-gradient(135deg, #1a56b8 0%, #174291 100%);
    border-radius: 12px;
    display: flex;
    align-items: flex-start;
    box-shadow: 0 6px 20px rgba(26, 86, 184, 0.25);

    .value-label {
      color: rgba(255, 255, 255, 0.95);
      font-weight: 700;
      font-size: 14px;
      margin-right: 12px;
      padding: 3px 10px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 6px;
      flex-shrink: 0;
    }

    .value-text {
      color: rgba(255, 255, 255, 0.92);
      font-size: 14px;
      line-height: 1.7;
    }
  }

  .product-img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
    margin-top: 20px;
    transition: transform 0.35s ease, box-shadow 0.35s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
    }
  }

  ::v-deep .el-divider {
    margin: 0 0 24px;
    border-top-color: rgba(26, 86, 184, 0.1);
  }

  ::v-deep .el-tabs__nav-wrap::after {
    height: 0;
  }

  ::v-deep .el-tabs__item.is-left {
    height: 60px;
    width: 10em;
    font-size: 16px;
    color: #646566;
  }
  ::v-deep .el-tabs--left .el-tabs__item.is-left {
    text-align: left;
  }
  ::v-deep .el-tabs__item.is-left:hover {
    color: #1a56b8;
    font-size: 1.2em;
    font-weight: bolder;
  }
  ::v-deep .el-tabs__item.is-left.is-active {
    color: #1a56b8;
    font-size: 1.2em;
    font-weight: bolder;
  }

  .content {
    padding: 0 20px;
    img {
      width: 100%;
      max-width: 600px;
      object-fit: contain;
    }
    p {
      line-height: 2em;
    }
  }

  @media (max-width: 768px) {
    .navbar {
      padding: 10px 12px;
      overflow-x: auto;
      justify-content: flex-start;

      .el-menu {
        display: flex;
        flex-wrap: nowrap;
      }

      .el-menu-item {
        padding: 8px 14px;
        font-size: 12px;
        margin: 0 3px;
        white-space: nowrap;
        border-radius: 20px;
      }
      
      .menu-icon {
        font-size: 13px;
        margin-right: 4px;
      }
    }

    .container {
      flex-direction: column;
      padding: 0;

      .sidebar {
        width: 100%;
        position: static;
        max-height: none;
        border-right: none;
        border-bottom: 1px solid rgba(26, 86, 184, 0.06);

        .sidebar-inner {
          padding: 16px 16px;
        }

        .sidebar-title {
          font-size: 14px;
          margin-bottom: 12px;
        }

        .sidebar-list {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }

        .sidebar-item {
          padding: 7px 12px;
          font-size: 12px;
          margin-bottom: 0;
        }
      }

      .main-content {
        padding: 24px 4%;
      }
    }
    }

    .platform-intro {
      padding: 24px 20px 28px;
      border-radius: 14px;

      h2 {
        font-size: 22px;
      }

      .platform-desc {
        font-size: 14px;
        margin-top: 16px;
      }
    }

    .platform-section {
      padding: 20px 18px;
      border-radius: 12px;
      margin-bottom: 16px;

      .section-title {
        font-size: 18px;

        &::before {
          height: 16px;
          width: 3px;
          margin-right: 10px;
        }
      }

      .section-desc {
        font-size: 13px;
        margin-bottom: 20px;
        padding-left: 13px;
      }
    }

    .feature-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .feature-item {
      padding: 16px;
      border-radius: 12px;

      .feature-icon {
        font-size: 22px;
        width: 36px;
        height: 36px;
        margin-right: 12px;
        border-radius: 8px;
      }

      .feature-content h4 {
        font-size: 15px;
      }

      .feature-content p {
        font-size: 13px;
      }
    }

    .value-box {
      margin-top: 20px;
      padding: 14px 18px;
      flex-direction: column;
      gap: 8px;

      .value-label {
        align-self: flex-start;
      }
    }

    ::v-deep .el-tabs--left {
      flex-direction: column;

      .el-tabs__header {
        width: 100% !important;
        margin-bottom: 0 !important;
        border-bottom: 1px solid #e4e7ed;
      }

      .el-tabs__nav {
        display: flex;
        flex-wrap: wrap;
      }

      .el-tabs__item.is-left {
        width: auto !important;
        height: 48px;
        padding: 0 15px;
        border-right: none !important;
        border-bottom: 2px solid transparent;

        &.is-active {
          border-bottom-color: #1a56b8;
        }
      }

      .el-tabs__content {
        padding: 15px 0;
      }
    }

    .product-img {
      margin-top: 15px;
    }
  }

</style>